module.exports = __webpack_public_path__ + "static/media/ну.b95cad17.mp3";